module.exports = __webpack_public_path__ + "img/Icon_File_2px.ee031ece.svg";